var angular = require('angular');
var template = require('./template.pug')();

 angular
  .module("app.directives")
  .directive('inlineEditBtn', function($compile, ngDialog){
    return {
      restrict: 'E',
      scope: {
        type: '@type',
        save: '&',
        value: '&value',
        label: '@label',
        max: '='
      },

      link: function(scope, element, attrs){

        var templateItem;
        if(scope.type == 'text'){
          templateItem = require('./text.pug');
        }

        if(scope.type == 'multilinetext'){
          templateItem = require('./multiLineText.pug');
        }

        if(scope.type == 'number'){
          templateItem = require('./number.pug');
        }

        if(scope.type == 'date'){
          templateItem = require('./date.pug');
        }

        scope.open = function(){

          var value = scope.value();
          if(scope.type == 'date'){
            var date = new Date(value);
            value = date;
          }

          var dialog = ngDialog.open({
            template: templateItem(),
            controller: require('./controller.js'),
            plain: true,
            disableAnimation: true,
            resolve: {
              value: function() { return value; },
              label: function() { return scope.label; },
              max: function() { return scope.max}
            }
          })

          dialog.closePromise.then(function (result) {

            if (result.value.type == 'submit'){
              scope.save()(result.value.value);
            }
          })
        }



        //deals with image VS element (text) for displaying the edit icon
        scope.isImage = (element[0].tagName === 'IMG');

        var compiled = $compile(template)(scope);

        if (scope.isImage) {
          element.wrap('<div class="btn-inline-wrap"></div>');
          element.after(compiled);
        } else {
          element.prepend(compiled);
        }

        element.addClass('btn-inline-root');
      }
    }
  })
